<template>
  <CDialog v-model="isOpen" class="dialog--small">
    <header class="dialog-header align-items-center">
      <div class="flex-fill">
        <h1 class="h4 mrgv0">
          {{ $t('ringtone.title') }}
        </h1>
      </div>

      <Btn variant="icon" @click="isOpen = !isOpen">
        <Icon id="close" :scale="0.75" />
      </Btn>
    </header>

    <div class="dialog-body">
      <template v-if="availableDevices.length">
        <div>{{ $t('ringtone.description') }}</div>

        <ListStacked class="list-stacked--dark mrgt" divided>
          <li v-for="(device, index) in availableDevices" :key="index">
            <Btn
              variant="bare"
              :class="[
                'ringtone__device',
                { 'ringtone__device--active': isActive(device.deviceId) },
              ]"
              @click="toggleRingtoneDevice(device)"
            >
              <Icon
                :id="isActive(device.deviceId) ? 'check' : 'uncheck'"
                :scale="0.75"
                class="mrgr--"
              />
              {{ device.label }}
            </Btn>
          </li>
        </ListStacked>
      </template>

      <template v-else>
        <div>{{ $t('ringtone.unavailable') }}</div>
      </template>
    </div>
  </CDialog>
</template>

<script>
import { twilioDevice } from '@/services/twilio';
import eventBus from '@/eventBus';

export default {
  data() {
    return {
      isOpen: false,
      availableDevices: [],
      activeDevices: [],
    };
  },

  watch: {
    isOpen: {
      handler() {
        if (twilioDevice) {
          const devices = Array.from(twilioDevice.audio.ringtoneDevices.get());
          devices.forEach(device => {
            if (!this.activeDevices.includes(device)) {
              this.activeDevices.push(device);
            }
          });
        }

        navigator.mediaDevices.enumerateDevices().then(devices => {
          this.availableDevices = devices.filter(
            device => device.kind === 'audiooutput'
          );
        });
      },
      immediate: true,
    },
  },

  mounted() {
    eventBus.$on('toggleRingtoneDialog', this.handleToggle);
  },

  beforeDestroy() {
    eventBus.$off('toggleRingtoneDialog', this.handleToggle);
  },

  methods: {
    handleToggle() {
      this.isOpen = !this.isOpen;
    },

    isActive(deviceId) {
      return this.activeDevices.find(
        activeDevice => activeDevice.deviceId === deviceId
      );
    },

    async toggleRingtoneDevice(device) {
      let activeDevices = this.activeDevices;

      if (!this.isActive(device.deviceId)) {
        activeDevices.push(device);
      } else if (this.isActive(device.deviceId) && activeDevices.length > 1) {
        activeDevices = activeDevices.filter(
          activeDeviceId => activeDeviceId.deviceId !== device.deviceId
        );
      }

      await twilioDevice.audio.ringtoneDevices
        .set(activeDevices.map(activeDevice => activeDevice.deviceId))
        .then(response => {
          this.activeDevices = activeDevices;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ringtone__device {
  .icon {
    color: $alt-500;
  }

  &:hover,
  &.ringtone__device--active {
    color: $brand-700;

    .icon {
      color: $brand-600;
    }
  }

  &.ringtone__device--active {
    font-weight: bold;
  }
}
</style>
